import * as React from "react";
import { Authenticated, AuthLoading, Unauthenticated } from "convex/react";
import { Spinner } from "@radix-ui/themes";
import { Navigate } from "../common/Navigate.tsx";
import { routes } from "../routing/router.ts";
import "./layout.css";

/** Its children once signed in; off to the sign-in page if not. */
export const RequireSignIn: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <>
    <Authenticated>{children}</Authenticated>
    <Unauthenticated>
      <Navigate to={routes.signIn()} />
    </Unauthenticated>
    <AuthLoading>
      <div className="shell-loading">
        <img src="/logo.webp" alt="" width={96} height={96} />
        <Spinner size={"3"} />
      </div>
    </AuthLoading>
  </>
);
